"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Per [WCAG guidance](https://www.w3.org/WAI/WCAG21/Understanding/animation-from-interactions.html),
 * use this style to avoid using unnecessary animation.
 *
 * This must apply to motion animation, which WCAG
 * defines as  "addition of steps between conditions to create the illusion of movement or to give a
 * sense of a smooth transition"
 *
 * NOTE: Motion animation does not include changes of color, blurring, or opacity which do not change
 * the perceived size, shape, or position of the element
 */

var reducedMotionStyles = {
  "@media (prefers-reduced-motion: reduce)": {
    // Sets the trasition to none. The transform will still occur but when transform
    // is set to none then no animation will occur
    transition: "transform 1ms"
  }
};
var _default = reducedMotionStyles;
exports["default"] = _default;